import { render } from "./Navbar.vue?vue&type=template&id=d2198bc8&scoped=true"
const script = {}

import "./Navbar.vue?vue&type=style&index=0&id=d2198bc8&lang=scss&scoped=true"

import exportComponent from "/Users/andyhsieh/Desktop/tourist-site-project-master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2198bc8"]])

export default __exports__